'use strict'
import fetch from "../libs/@elements/fetch";
import {onFind} from "../libs/@elements/init-modules-in-scope";


export function init() {
    onFind('form[name=pro_access_registration_form]', function (form) {
        const select = form.elements['pro_access_registration_form_proType']
        select.addEventListener('change', function (el) {
            onFind('#required-application-data', function (container) {
                const selectedId = el.target.value
                if (selectedId) {
                    const url = form.getAttribute('data-required-application')
                    fetch(`${url}?id=${selectedId}`, {})
                        .then(response => response.json())
                        .then(response => {
                            if (response.content) {
                                container.removeAttribute('hidden')
                                container.firstElementChild.innerHTML = response.content
                                return
                            }
                            container.setAttribute('hidden', true)
                        })
                }
                container.setAttribute('hidden', true)
            })
        })
    })
}
